import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  convertUTCStringToOffset,
  isLargeScreen,
} from '../../../../global.variable';
import { JobsService } from '../../../pages/pages/jobs/jobs.service';
import { MediaPreviewComponent } from '../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ModifyLetterheadLogoComponent } from '../../../shared/components/modify-letterhead-logo/modify-letterhead-logo.component';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { AppService } from '../../../app.service';

@Component({
  selector: 'gtapp-preview-report',
  standalone: false,
  templateUrl: './preview-report.component.html',
  styleUrl: './preview-report.component.scss',
})
export class PreviewReportComponent implements OnInit, OnDestroy {
  largeView = isLargeScreen;
  job_details: any;
  detailData: any;

  statusTimeStamps: any = [];
  eventsOutsideStatusTimeStamps: any = [];
  timeZoneOffset: any;
  welfareCheckPresent: boolean = false;
  photoUploadPresent: boolean = false;
  cpScanPresent: boolean = false;
  completedTasksPresent: boolean = false;
  hasStatusUpdates: boolean = false;
  completedTasksData: any = [];
  summaryData: any = [];
  eventData: any = [];
  promptFileDataUrls: any = [];

  customStatusOrder = [-1, 0, 8, 4, 5, 1];

  isSubContractingClient: boolean = false;

  constructor(
    private spinnerService: LoadingSpinnerService,
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private appService: AppService,
  ) {}

  ngOnInit(): void {
    this.getJobDetails();
  }
  ngOnDestroy(): void {}

  copyContentToClipBoard(content: string) {
    // this.clipboard.copy(couponData?.event?.code);
    this.toasterService.copyContentToClipBoard(content);
  }
  getJobDetails() {
    let id = this.route.snapshot.queryParamMap.get('jobId');

    if (!id) {
      this.router.navigate(['/pc']);
    }

    this.jobService
      .getJobById(id, { preview_report: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.show();

          this.formatData(response);
        } else {
          this.spinnerService.hide();
        }
      });
  }
  formatData(response: any) {
    this.detailData = response?.job_details || {};

    this.detailData.additional_info = this.detailData?.additional_info || {};
    const hideGuardColumn = this.detailData?.additional_info?.hide_guard_column;

    if (typeof hideGuardColumn !== 'boolean') {
      this.detailData.additional_info.hide_guard_column = true;
    }

    this.cpScanPresent = response?.data?.has_cp_scan_events;
    this.completedTasksPresent = response?.data?.has_completed_tasks;
    this.hasStatusUpdates = response?.data?.has_status_updates;
    this.isSubContractingClient = response?.data?.is_subcontracting || false;
    this.completedTasksData = response?.data?.completed_task_data || [];
    this.promptFileDataUrls = response?.data?.prompt_file_data_list || [];

    this.job_details = response?.data?.job_details;
    this.timeZoneOffset = convertUTCStringToOffset(
      this.job_details?.time_zone_diff,
    );

    this.eventData = response?.data?.event_data;
    this.summaryData = response?.data?.summary_data;

    this.welfareCheckPresent = false;
    this.photoUploadPresent = false;
    let lastUpdatedStatusDict: any = {};
    if (
      [0].includes(this.detailData?.service_type?.type_identity) &&
      this.detailData?.job_received_at
    ) {
      lastUpdatedStatusDict['Alarm Received'] = {
        event_time: this.detailData?.job_received_at,
        status_identity: -1,
        value: 'Alarm Received',
      };
    }

    this.eventData?.forEach((update: any) => {
      if (update?.event_type !== 4) {
        if (
          update?.event_action === 1 &&
          [4, 5, 8, 0, 1].includes(update?.status_identity)
        ) {
          lastUpdatedStatusDict[update?.value] = update;
        }
        if (update?.event_action === 20) {
          this.welfareCheckPresent = true;
        }
        if ([8, 19].includes(update?.event_action)) {
          this.photoUploadPresent = true;
        }
      }
    });

    // if (this.detailData?.service_type?.type_identity !== 2) {
    //   // Re open not available for static guard
    //   this.lastStatus = this.detailData?.service_type?.statuses?.find(
    //     // offsite status
    //     (s: any) => s?.status?.status_identity?.value === 5,
    //   );

    //   if (!this.lastStatus?.status?.id) {
    //     this.lastStatus = this.detailData?.service_type?.statuses?.find(
    //       (s: any) =>
    //         s?.status?.status_identity?.value === 0 &&
    //         s?.status?.name?.toLowerCase() === 'in progress',
    //     );
    //   }
    // }
    // some job types may not have onsite and or offsite. so get the time from the statusTimestapms
    let onSiteTime: any;
    let offsiteTime: any;

    if (Object.keys(lastUpdatedStatusDict)?.length) {
      try {
        let sortedArray = Object.entries(lastUpdatedStatusDict)
          .sort(
            (a: any, b: any) =>
              new Date(a[1].event_time).getTime() -
              new Date(b[1].event_time).getTime(),
          )
          ?.map(([key, value]) => ({ [key]: value }));

        // Optionally, convert back to a dictionary if needed
        lastUpdatedStatusDict = Object.assign({}, ...sortedArray);
      } catch (error) {}
    }

    this.statusTimeStamps = Object.values(lastUpdatedStatusDict);

    this.statusTimeStamps?.forEach((status: any, index: number, arr: any) => {
      if (index > 0) {
        const prevStatus = arr[index - 1];
        const prevOrderIndex = this.customStatusOrder?.indexOf(
          prevStatus?.status_identity,
        );
        const currOrderIndex = this.customStatusOrder?.indexOf(
          status?.status_identity,
        );

        if (currOrderIndex < prevOrderIndex) {
          status.sortInfo = `up`;
          prevStatus.sortInfo = `down`;
        }
      }

      if (status?.status_identity === 4)
        onSiteTime = new Date(status?.event_time).getTime();
      if (status?.status_identity === 5)
        offsiteTime = new Date(status?.event_time).getTime();
    });

    if (onSiteTime && offsiteTime) {
      // filter items outisde onsite and offsite

      this.eventsOutsideStatusTimeStamps = this.eventData
        ?.filter(
          (item: any) =>
            [7, 8, 19].includes(item?.event_action) &&
            item?.event_type !== 4 &&
            !item?.is_deleted &&
            (new Date(item?.event_time).getTime() <= onSiteTime ||
              new Date(item?.event_time).getTime() >= offsiteTime),
        )
        ?.map((item: any) => item?.id);
    }
    // const targetUrl = `/job-review/${this.detailData.job_key}`;

    // if (this.router.url !== targetUrl) {
    //   this.router.navigate([targetUrl], { replaceUrl: true });
    // }

    this.getShiftStartEnd();
    this.spinnerService.hide();
  }
  getShiftStartEnd() {
    if (this.detailData?.roster_scheduler?.repeat_type) {
      let startTime = this.detailData?.schedule_event_date
        ? new Date(this.detailData?.schedule_event_date)
        : new Date();
      let endTime = this.detailData?.schedule_event_date
        ? new Date(this.detailData?.schedule_event_date)
        : new Date();

      if (this.detailData?.roster_scheduler?.repeat_type == 'once') {
        startTime = new Date(
          this.detailData?.roster_scheduler?.start_day +
            ' ' +
            this.detailData?.roster_scheduler?.start_time,
        );
        endTime = new Date(
          this.detailData?.roster_scheduler?.end_day +
            ' ' +
            this.detailData?.roster_scheduler?.end_time,
        );
      } else {
        if (
          this.detailData?.roster_scheduler?.start_time >
          this.detailData?.roster_scheduler?.end_time
        ) {
          endTime.setDate(startTime.getDate() + 1);
        }
        this.setTime(startTime, this.detailData?.roster_scheduler?.start_time);
        this.setTime(endTime, this.detailData?.roster_scheduler?.end_time);
      }

      this.detailData.roster_scheduler.shiftStartDateTime = startTime;
      this.detailData.roster_scheduler.shiftEndDateTime = endTime;
      this.detailData.roster_scheduler.shiftDuration = this.getTimeDiff(
        startTime,
        endTime,
      );
    }
  }

  setTime(date: Date, time: string) {
    const [hours, minutes] = time?.split(':');
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));
  }
  getTimeDiff(startTime: any, endTime: any) {
    let diffInTime = endTime?.getTime() - startTime?.getTime();

    if (!diffInTime) return '00:00';
    let seconds = Math.floor(diffInTime / 1000);
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);

    return `${this.pad(hours)}:${this.pad(minutes)}`;
  }
  pad(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  modifyLetterHeadLogo() {
    const dialogRef = this.dialogService.open(ModifyLetterheadLogoComponent, {
      data: {
        logoUsed: this.job_details?.subscriber_info?.logo_used,
        siteData: {
          id: this.detailData?.sites?.[0]?.id,
          company_name: this.detailData?.sites?.[0]?.company_name,
        },
        clientData: {
          id: this.detailData?.company?.id,
          company_name: this.detailData?.company?.company_name,
          is_subcontracting: this.detailData?.company?.is_subcontracting,
        },
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getJobDetails();
      }
    });
  }
  scrollToSection(event: Event, sectionId: string) {
    event.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: srcAttr.nodeValue, timeStamp: data.updated_at },
    });
  }
  async onEmailReport() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Email Report',
      },
    });
    const dialogResponse = await firstValueFrom(dialogRef.afterClosed());

    if (dialogResponse === true) {
      const subscriberUserId =
        this.appService.getUserData()?.subscriber?.subscriber_user_id;

      let requestData: any = {};
      requestData['method'] = 'put';
      requestData['url'] = 'api/job/' + this.detailData.id + '/';
      requestData['id'] = this.detailData.id;
      requestData['data'] = {
        recipient_ids: [subscriberUserId],
        resend_report: true,
      };
      this.spinnerService.show('Mailing Report');
      this.jobService
        .updateJob(requestData, { preview_report: 1 })
        .then((response: any) => {
          if (response?.data) {
            this.formatData(response);
          }
          if (response?.status === 'failure') {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response?.message,
            });
          }

          this.spinnerService.hide();
        });
    }
  }
}
